import React, { useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RibbonBar, RibbonDivider, RibbonSection } from 'common/components';
import GridViewSelector from 'common/components/grid-view/controllers/selectors';
import { Menu, Dropdown } from 'antd';
import RibbonButton from 'common/components/button/RibbonButton';
import * as globalActions from '@redux/global/actions';
import { FileTextOutlined,  FolderOpenOutlined } from '@ant-design/icons';
import { useFolderByLevel } from 'hooks/useFolderByLevel';
import { OtherLayout, ViewLayout, AdvanceStack } from './components';
import CertificateModalManager from '../../branded-assets-certificates/components/panel/CertificateModalManager';
import * as selectors from '../../branded-assets-certificates/controllers/selectors';
import { CustomNotification } from 'common/components';
import { useCheckAllowEditContact } from 'hooks/useCheckIsSuperUser';
import {
  useCheckIsSuperAdmin
} from 'hooks';


const CertificatesGridDetail = () => {
  const selectedCertificateDetail = useSelector(selectors.makeSelectCertificateData());
  const certificateId = selectedCertificateDetail && selectedCertificateDetail.id


  const { keepFolderBreadcrumb } =
    useFolderByLevel();


  const hasPermissionCertificateEdit = useCheckAllowEditContact();
  const isSuperAdmin = useCheckIsSuperAdmin();
  

  const enableManageLinks = (isSuperAdmin || hasPermissionCertificateEdit);

  // enable Preview when a single item is selected
  const isDisabled = certificateId === undefined;

  const modalRef = useRef({});
  const handleExpose = (handlers) => {
    modalRef.current = handlers;
  };
  const closeDetailCallback = () => {
    keepFolderBreadcrumb(true);
  };

  const menu = (
    <Menu>
      <Menu.Item key="add" onClick={() => modalRef.current.handleAdd()}>
        Add Certificate
      </Menu.Item>
      <Menu.Item
        key="update"
        onClick={() => {
          if (selectedCertificateDetail) {
            modalRef.current.handleEdit(selectedCertificateDetail);
          } else {
            CustomNotification.warning('Please select one certificate to edit');
          }
        }}
        disabled={isDisabled}
      >
        Update Certificate
      </Menu.Item>
      <Menu.Item
        key="delete"
        onClick={() => {
          if (selectedCertificateDetail) {
            modalRef.current.handleDelete(selectedCertificateDetail);
          } else {
            CustomNotification.warning('Please select one certificate to delete');
          }
        }}
        disabled={isDisabled}
      >
        Delete Certificate
      </Menu.Item>
      <Menu.Item
        key="download"
        onClick={() => {
          if (selectedCertificateDetail) {
            modalRef.current.handleDownload(selectedCertificateDetail);
          } else {
            CustomNotification.warning('Please select one certificate to download');
          }
        }}
      >
        Download Certificate
      </Menu.Item>

    </Menu>
  );

  return (
    <>
      <RibbonBar>
        {enableManageLinks && (
          <RibbonSection>
            <Dropdown overlay={menu} placement="bottomLeft">
              <RibbonButton label={'Certification Actions'} disabled={isDisabled} icon={<FileTextOutlined />} />
            </Dropdown>
          </RibbonSection>
        )}
        <OtherLayout
          ribbonSide='right'
          ribbonType='certificates'
          closeDetailCallback={closeDetailCallback}
        />
      </RibbonBar>
      <CertificateModalManager isDetailPage={true} onExpose={handleExpose} />
    </>
  );
};

export default CertificatesGridDetail;
